import type { DocumentResponse, CreateDocumentRequest, MarkUploadedRequest } from '@/types/upload';
import { apiRequest } from './apiClient';

/**
 * Strategy-specific upload API service.
 * Uses strategy upload endpoints which generate S3 keys at sparkapp/assets/strategies/
 */
export const strategyUploadApi = {
  /**
   * Create a new strategy document and get signed upload URL
   */
  async createDocument(data: CreateDocumentRequest): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(
      '/admin/strategies/upload/create',
      {
        method: 'POST',
        body: data,
      }
    );
    return result.data;
  },

  /**
   * Mark strategy document as uploaded
   */
  async markAsUploaded(data: MarkUploadedRequest): Promise<void> {
    await apiRequest<void>('/admin/strategies/upload/mark-uploaded', {
      method: 'POST',
      body: data,
    });
  },

  /**
   * Get strategy document details with fresh signed URLs
   */
  async getDocument(documentId: number): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(
      `/admin/strategies/upload/${documentId}`
    );
    return result.data;
  },
};
